/*
 * @Author: bobo 350910378@qq.com
 * @Date: 2023-02-25 18:50:41
 * @LastEditors: bobo 350910378@qq.com
 * @LastEditTime: 2023-02-25 19:20:08
 * @FilePath: \baishu_react_ui\src\utils\WidgetFilter.jsx
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */


import { BsyUtils } from '../Utils';
import camelCase from "lodash/camelCase";



export default class WidgetFilter {
  //items 表单字段
  //row  表单行数
  //firstWidget 触发的字段
  constructor(props) {
    this.options = {
      method: "",
      value: [],
      ...props,
    }


    this._init()

  }
  _init() { }
  _isConfigValid() {
    return !0
  }
  _getInvalidValue() {
    return function () {
      return !1
    }
  }
  _getNullValues() {
    return [null, void 0, "", [], {}]
  }
  invoke() {
    var t = this.options;
    if (!this._isConfigValid())
      return this._getInvalidValue();
    var e = camelCase(t.method);
    return BsyUtils.applyFunc(this, this[e], t.value, this._getInvalidValue())
  }

}